import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/star.png'
import _imports_1 from '@/assets/images/standard.png'
import _imports_2 from '@/assets/images/standard2.png'
import _imports_3 from '@/assets/images/yjzldy.png'
import _imports_4 from '@/assets/images/gjts.png'
import _imports_5 from '@/assets/images/fx_icon.png'
import _imports_6 from '@/assets/images/fs_wu.png'


const _hoisted_1 = { class: "fly-replay-nav" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = { class: "nav-left" }
const _hoisted_4 = { class: "nav-title" }
const _hoisted_5 = { class: "nav-right" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "item-value score-value" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "fly-replay-content" }
const _hoisted_11 = { class: "content-main" }
const _hoisted_12 = { class: "scene-control-card" }
const _hoisted_13 = {
  key: 0,
  class: "blur-container"
}
const _hoisted_14 = { class: "blur-inner-container" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "loading-container" }
const _hoisted_17 = { class: "progress-container" }
const _hoisted_18 = { class: "prompt-box-container" }
const _hoisted_19 = { class: "prompt-container" }
const _hoisted_20 = { class: "prompt-text-cotainer" }
const _hoisted_21 = {
  src: _imports_3,
  alt: ""
}
const _hoisted_22 = {
  src: _imports_4,
  alt: ""
}
const _hoisted_23 = { class: "wind-info-container" }
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "info-box" }
const _hoisted_26 = { class: "info-item wind-speed-item" }
const _hoisted_27 = { class: "info-box" }
const _hoisted_28 = { class: "speed-value-item" }
const _hoisted_29 = {
  key: 0,
  class: "label"
}
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "joystick-container" }
const _hoisted_32 = { class: "box-container" }
const _hoisted_33 = { class: "box-container" }
const _hoisted_34 = { class: "miniMap-container" }
const _hoisted_35 = { class: "replay-control-card" }
const _hoisted_36 = { class: "control-top" }
const _hoisted_37 = { class: "play-section" }
const _hoisted_38 = { class: "time-text" }
const _hoisted_39 = { class: "current-time" }
const _hoisted_40 = { class: "speed-section" }
const _hoisted_41 = { class: "speed-text" }
const _hoisted_42 = { class: "speed-dropdown" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "timeline-container" }
const _hoisted_45 = { class: "timeline-label-container" }
const _hoisted_46 = { class: "deviation-tracks" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "content-side" }
const _hoisted_49 = { class: "side-card flight-path-card" }
const _hoisted_50 = { class: "card-content" }
const _hoisted_51 = { class: "side-card flight-summary-card" }
const _hoisted_52 = { class: "card-content" }
const _hoisted_53 = { class: "summary-text" }
const _hoisted_54 = { class: "side-card training-suggest-card" }
const _hoisted_55 = { class: "card-content" }
const _hoisted_56 = { class: "suggest-text" }

import { ref, onMounted, onUnmounted, watch, nextTick, onBeforeMount, reactive, Ref,computed,onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import useFlightEchartOptions from '@/hooks/useFlightEchartOptions'
import CircleDrawer from '@/utils/drawer/CircleDrawer'
import {enterOrExitUavSimulateModule, resetView,updateReplayData,locateToTimePoint} from '@/webapi'
import useReceiveMessage, { getCanvasLimitHeight } from '@/hooks/useReceiveMessage'
import { getDeviationColor,getWindSpeed,createRandomWind } from '@/utils'
import miniMap from '@/components/modules/miniMap/index.vue'
import useSpeechSynthesis from '@/hooks/useSpeechSynthesis'
import {NProgress} from 'naive-ui'
import { $config } from '@/global'

const singleScreenMinutes = 180000; // 单屏最大展示3分钟（180000毫秒）
const userScrollTimer = null as any
const scrollTimeout = 3000

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // 导航栏标题
  title: {
    type: String,
    default: '8字飞行'
  },
  // 得分
  score: {
    type: [Number, String],
    default: 0
  },
  // 是否合格
  isPass: {
    type: Boolean,
    default: false
  },
  // 评价
  rating: {
    type: String,
    default: '暂无评价'
  },
  // 飞行总结
  flightSummary: {
    type: String,
    default: '暂无总结'
  },
  // 训练建议
  trainingSuggestion: {
    type: String,
    default: '暂无建议'
  },
  trainingId:{
    type: String,
    default: ''
  },
  // 偏差信息
  deviationInfo: {
    type: Object as () => {
      angle?: string           // 角速度偏差
      headAngle?: string       // 夹角偏差
      height?: string       // 高度偏差
      position?: string       // 位置偏差
      speed?: string         // 速度偏差
    },
    default: () => ({})
  },
  // 能力分析数据
  abilityData: {
    type: Object as () => {
      flight_stability?: number      // 飞行稳定性
      stick_proficiency?: number     // 打杆熟练度
      anti_disturbance?: number      // 抗干扰
      error_correction?: number      // 纠错反应
      deviation_control?: number     // 偏差控制
    },
    default: () => ({
      flight_stability: 0,
      stick_proficiency: 0,
      anti_disturbance: 0,
      error_correction: 0,
      deviation_control: 0
    })
  },
  // 风向
  windDirection: {
    type: String,
    default: ''
  },
  // 风速
  windSpeed: {
    type: Number,
    default: -1
  },
  //入口类型  1: 飞行 ，2：成绩
  enterMode: {
    type: Number,
    default: 1
  },
  // 页面模式 1: 训练 2: 考试
  pageMode: {
    type: Number,
    default: 1
  },
  // 场景图片
  scenePictureUrl: {
    type: String,
    default: ''
  }
},
  emits: [
  'close'
],
  setup(__props, { emit: __emit }) {

const store = useStore()

// Props 定义
const props = __props

// Emits 定义
const emits = __emit

// 播放状态
const showSpeedDropdown = ref(false)
const speedOptions = [0.5, 1, 2, 4]
const progressValue = ref(0)
let progressTimer = null as any
let isProgressRunning = ref(false)

// 时间轴配置
const timelineItems:Ref<{label:string,color:string,code:string,evaluateAlarmList:any[]}[]> = ref([])

// 电子桩
const drawer = ref(null) as any
const drawRef = ref(null)

const containerRef = ref(null)
const timelineRef = ref(null)
const userScrolling = ref(false)
const isDragging = ref(false)
const draggingtime = ref(0)
const state = reactive({
  totalTime: 0,
  currentTime: 0,
  playbackSpeed: 1,
  isPlaying: false,
  exceptionPlaying: false,
  exceptionEndTime:0,
  evaluateAlarmList:[] as any[],
  joystickValue:{
    leftX:50,
    leftY:50,
    rightX:50,
    rightY:50
  },
  prompt_text:'',
  showInfoPrompt:false,
  prompt_type:'',
  currentExceptionCode:'',
  currentExceptionIndex:-1,
  currentExpectionEndTime:-1,
  showMiniMap:false,
 })
const pointDataList = ref([] as any[])
const evaluatePointList = ref(new Map())

// 计算属性
const playheadLeft = computed(()=>{
  let currentTime = isDragging.value ? draggingtime.value : state.currentTime
  const currentPosition = (currentTime / state.totalTime) * 100
  const timerWidth = document.getElementById('playheadId')?.clientWidth || 0
  const trackWidth = getTrackPixelWidth()
  const widthPercent = (timerWidth / trackWidth) * 100
  return Math.min(currentPosition, 100 - widthPercent)
})

const currentTime = computed(()=>{
  return isDragging.value ? draggingtime.value : state.currentTime
})

const windSpeed = computed(()=>{
  if(props.pageMode == 1){
    return getWindSpeed(props.windSpeed)
  }else{
    return {value: createRandomWind().speed.replace(',','~')}
  }
})

const trackWidth = computed(() => {
  return Math.max(100, (state.totalTime / singleScreenMinutes) * 100);
});

// 监听数据变化
watch(() => props.abilityData, () => {
  updateRadarData(props.abilityData)
}, { deep: true })

// 雷达图 hook
const { initEcharts, resizeEcharts, updateRadarData } = useFlightEchartOptions()
const { speak,stop } = useSpeechSynthesis()

const typeMap = new Map([
  ['notifyRunningParam', 'notifyRunningParam'], //运行数据回调
  ['notifyReplayData', 'notifyReplayData'], //回放数据回调
  ['loadSceneResource', 'loadSceneResource'], //加载模型完成
])

useReceiveMessage(typeMap, (type: string, data: any) => {
  if(type === 'notifyReplayData'){
    const {currentTime,totalTime,speed,evaluateAlarmList,pointList} = data.data || {}
    Object.assign(state,{
      currentTime,
      totalTime,
      playbackSpeed: speed || 1,
      evaluateAlarmList: evaluateAlarmList || [],
      showMiniMap: true
    })
    pointDataList.value = pointList || []
    evaluatePointList.value = new Map()
    let evaluatePointListMap = new Map()
    evaluateAlarmList.forEach((item: any) => {
      let obj = {}
      if(item.code === 'angleOffset'){
        obj = {mapPosition:item.mapPosition,color:getDeviationColor('headAngle')}
      }else if(item.code === 'angleSpeedOffset'){
        obj = {mapPosition:item.mapPosition,color:getDeviationColor('angle')}
      }else if(item.code === 'speedOffset'){
        obj = {mapPosition:item.mapPosition,color:getDeviationColor('speed')}
      }else{
        let code = item.code.split('Offset')[0]
        obj = {mapPosition:item.mapPosition,color:getDeviationColor(code)}
      }
      if(evaluatePointListMap.has(item.timestamp)){
        let list = evaluatePointListMap.get(item.timestamp)
        list.push(obj)
        evaluatePointListMap.set(item.timestamp, list)
      }else{
        evaluatePointListMap.set(item.timestamp, [obj])
      }
    })
    evaluatePointList.value = evaluatePointListMap


    let timelineList: any = []
    Object.entries(props.deviationInfo).forEach(([key, value]) => {
      let item = { label: value, color: getDeviationColor(key), code: key, evaluateAlarmList: [] }
      if(key === 'headAngle'){
        item.evaluateAlarmList = evaluateAlarmList.filter(item => item.code === 'angleOffset')
      }else if(key == 'angle'){
        item.evaluateAlarmList = evaluateAlarmList.filter(item => item.code === 'angleSpeedOffset')
      }else if(key == 'speed'){
        item.evaluateAlarmList = evaluateAlarmList.filter(item => item.code === 'speedOffset')
      }else{
        item.evaluateAlarmList = evaluateAlarmList.filter(item => item.code === `${key}Offset`)
      }
      timelineList.push(item)
    })
    timelineItems.value = timelineList
  }

  if(type == "notifyRunningParam"){
    if(isProgressRunning.value){
      stopProgress()
      isProgressRunning.value = false
    }
    const {realTimeReplayData,taskData} = data.data || {}
    const {currentTime, speed, play,joystickValue,evaluateAlarmList,messageData } = realTimeReplayData || {}
    let lx = 0, ly = 0, rx = 0, ry = 0;
    if(joystickValue){
      lx = ((joystickValue[1] || 0) + 1) / 2 * 100
      ly = ((joystickValue[2] || 0) * -1 + 1) / 2 * 100
      rx = ((joystickValue[3] || 0)  + 1) / 2 * 100
      ry = ((joystickValue[4] || 0) * -1 + 1) / 2 * 100
    }
    Object.assign(state,{
      currentTime,
      playbackSpeed: speed || 1,
      isPlaying: play == 1,
      joystickValue:joystickValue?{
        leftX:  Math.max(4, Math.min(94, lx)),
        leftY:  Math.max(4, Math.min(94, ly)),
        rightX:  Math.max(4, Math.min(94, rx)),
        rightY:  Math.max(4, Math.min(94, ry))
      }: {leftX:0,leftY:0,rightX:0,rightY:0},
    })

    if(state.totalTime > currentTime){
      state.isPlaying = play == 1
    }else{
      if(state.isPlaying){
        state.isPlaying = false
      }
    }

    //自动滚动
    if(play == 1){
      updatePlayheadScroll()
    }

    // 绘制电子桩
    if(!drawer.value && taskData?.evaluateData?.["positionOffset"]){
      let positionOffset = taskData?.evaluateData?.["positionOffset"]
      let {mapPosition,mapYaw} = taskData || {}
      const w = positionOffset.maxValue * 10 * 2;
      drawer.value = new CircleDrawer(drawRef?.value,w,{x:mapPosition.x,y:mapPosition.y,yaw:mapYaw})
    }

    if(drawer.value && play == 1){
      let {mapPosition,mapYaw} = taskData || {}
      drawer.value.updateCompass({
        x:mapPosition.x,
        y:mapPosition.y,
        yaw:mapYaw
      })

      // 绘制偏差点
      if(evaluateAlarmList && Array.isArray(evaluateAlarmList) && evaluateAlarmList.length > 0){
        evaluateAlarmList.forEach((item: any) => {
          if(evaluatePointList.value.has(item.timestamp)){
            let list = evaluatePointList.value.get(item.timestamp)
            list.forEach((obj: any) => {
              drawer.value.drawCircle({
                x:obj?.mapPosition.x,
                y:obj?.mapPosition.y
              }, obj.color)
            })
          }
        })
      }
    }

    // 提示消息
    if(messageData){
      let {message, messageType, show} = messageData || {}
      state.showInfoPrompt = show
      if(show){
        state.prompt_type = messageType
        state.prompt_text = message
        speak(message)
      }
    }

    //描边逻辑
    if(state.currentExpectionEndTime !== -1 && state.currentExpectionEndTime < currentTime){
      state.currentExpectionEndTime = -1
      state.currentExceptionCode = ''
      state.currentExceptionIndex = -1
    }
  }

  if(type === 'loadSceneResource'){
    if(props.enterMode == 2){
      //从成绩页面进入
      enterOrExitUavSimulateModule({
        enter:true,
        canvasLimitHeight:getCanvasLimitHeight(store.state.persistence.resolution),
        trainingData:{id:props.trainingId, replayMode:1}
      })
    }
  }
})

// 启动模拟进度
const startProgress = () => {
  progressValue.value = 0
  progressTimer = setInterval(() => {
    // 每次增加 1-5%，随机递增
    progressValue.value = Math.min(
      progressValue.value + Math.random() * 5 + 1, 
      95  // 最大到 95%，等待真实消息
    )
  }, 100)
}

// 停止进度（收到加载完成消息时调用）
const stopProgress = () => {
  if (progressTimer) {
    clearInterval(progressTimer)
    progressTimer = null
  }
  progressValue.value = 100  // 设置为完成
}

//========================   时间轴
// 获取轨道实际像素宽度（用于滚动计算）
const getTrackPixelWidth = () => {
  return containerRef.value?.firstElementChild?.offsetWidth || 0;
}

// 格式化时间
const formatTime = (seconds: number): string => {
  const totalSeconds = Math.floor(seconds / 1000)
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = Math.floor(totalSeconds % 60)
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

// 播放/暂停
const handlePlayPause = () => {
  if(state.totalTime > state.currentTime){
    updateReplayData({play: state.isPlaying ? 0 : 1})
  }else{
    if(!state.isPlaying){
      locateToTimePoint({locateTime: 0})
      updateReplayData({play: state.isPlaying ? 0 : 1})
      resetDrawer(0)
    }
  }
}

// 选择播放速度
const selectSpeed = (speed: number) => {
  updateReplayData({speed})
  showSpeedDropdown.value = false
}

const onWheel = (e: WheelEvent) => {
  if(containerRef.value && e.deltaY !== 0){
    containerRef.value.scrollLeft += e.deltaY;
    onUserScroll();
  }

}

const onScroll = (e: Event) => {
  if(state.isPlaying){
    onUserScroll();
  }
}

const onUserScroll = ()=>{
  userScrolling.value = true
  clearTimeout(userScrollTimer.value);
  userScrollTimer.value = setTimeout(()=>{
    userScrolling.value = false
  },scrollTimeout)
}

//重置电子桩
const resetDrawer = (targetTime:number)=>{
  setTimeout(() => {
    const lastIndex = findLastIndexBeforeTime(pointDataList.value, targetTime)
    if(lastIndex !== -1 && drawer.value){
      const positionsBefore = pointDataList.value.slice(0,lastIndex+1).map(item => ({...item.mapPosition,yaw:item.mapYaw}))
      drawer.value.resetTrailPoints(positionsBefore)
    }

    // 重置偏差点
    if(drawer.value){
      const points = [...evaluatePointList.value].filter(([key]) => key <= targetTime).flatMap(([, value]) => value)
      drawer.value.resetCircles(points)
    }
  }, 10);
}

const onTimelineClick = (e: MouseEvent) => {
  // TODO: 实现时间线点击功能
  if (e.target.classList.contains('exception-bar')) return;
  const currentTime = getCurrentTime(e) as number;
  resetPrompt()  
  locateToTimePoint({locateTime: currentTime})
  resetDrawer(currentTime)
  if(isDragging.value){
    setTimeout(()=>{
      isDragging.value = false
    },20)
  }

}

const playException = (timestamp: number, expectionIndex:number, exceptionCode:string) => {
  const start = Math.max(0, timestamp - 3000);
  const end = Math.min(state.totalTime, timestamp + 3000);
  state.currentExpectionEndTime = end
  state.currentExceptionCode = exceptionCode
  state.currentExceptionIndex = expectionIndex
  resetPrompt()
  locateToTimePoint({locateTime: start, endTime: end})
  resetDrawer(start)
}

const updatePlayheadScroll = ()=>{
  if (!containerRef.value) return;
  if (userScrolling.value) return;
  // 播放头在轨道中的百分比位置 → 转为像素位置
  const playheadPercent = state.currentTime / state.totalTime;
  const trackPixelWidth = getTrackPixelWidth();
  const x = playheadPercent * trackPixelWidth;
  const containerWidth = containerRef.value.clientWidth;
  const visibleRight = containerRef.value.scrollLeft + containerWidth;

  if (x >= visibleRight) {
    containerRef.value.scrollLeft += containerWidth;
  } else if (x < containerRef.value.scrollLeft) {
    containerRef.value.scrollLeft = Math.max(0, x - containerWidth + 50);
  }
}

const onKeydown = (e: any) => {
  if(e.code === 'Space'){
    e.preventDefault();
    handlePlayPause()
  }
}

//计算样式
const getStyle = (timestamp: number) => {
  let width = (6000 / state.totalTime) * 100
  let left = ((timestamp - 3000) / state.totalTime ) * 100
  return {
    left: Math.min(left, 100 - width) + '%',  // 取较小值，保证不超限
    width: width + '%'
  }
}

/**
 * 查找在指定时间之前的时间点索引
 * @param data 电子桩轨迹点的数组
 * @param targetTime 目标时间
 * @returns 最后一个时间点的索引，若不存在则返回 -1
 */
const findLastIndexBeforeTime = (data:any[], targetTime: number) => {
  let left = 0
  let right = data.length - 1
  let result = -1
  while (left <= right) {
    const mid = (left + right) >> 1  // 等同 Math.floor((left+right)/2)，位运算更快
    if (data[mid].timestamp <= targetTime) {
      result = mid       // mid 满足条件，记录下来
      left = mid + 1     // 继续往右找更接近的
    } else {
      right = mid - 1    // 超了，往左找
    }
  }
  return result
}

// 获取评价样式类
const getRatingClass = (rating: string) => {
  switch (rating) {
    case '优秀':
      return 'rating-excellent'
    case '良好':
      return 'rating-good'
    case '较差':
      return 'rating-pass'
    default:
      return 'rating-pass'
  }
}

const resetPrompt = ()=>{
  stop()
  state.showInfoPrompt = false;
}


// 窗口大小变化时重绘雷达图
const handleResize = () => {
  updateEngineViewPosition()
  resizeEcharts()
  if(drawer.value){
    drawer.value.resizeHandler()
  }
}

// 计算并设置 engineView 的位置，使其占满目标容器
const updateEngineViewPosition = () => {
  const container = document.getElementById('fly-replay-engine-container');
  if (!container) return;

  const containerRect = container.getBoundingClientRect();
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  // 计算容器左上角在窗口中的位置
  const top = containerRect.top;
  const left = containerRect.left;

  // 计算容器宽高占窗口的百分比
  const widthPercent = (containerRect.width / windowWidth) * 100;
  const heightPercent = (containerRect.height / windowHeight) * 100;

  store.commit('viewData/setEngineViewPosition', {
    width: `${widthPercent}%`,
    height: `${heightPercent}%`,
    top: `${top}px`,
    left: `${left}px`,
    zIndex: 12,
  });
}

const handleMouseDown = (e: MouseEvent) => {
  if(state.isPlaying) return
  isDragging.value = true
};

// 计算当前时间
const getCurrentTime = (e: MouseEvent) => {
  if (!containerRef.value) return;

  const rect = containerRef.value.getBoundingClientRect();
  const x = e.clientX - rect.left + containerRef.value.scrollLeft;
  const trackPixelWidth = getTrackPixelWidth();

  return Math.min(
    Math.max(0, (x / trackPixelWidth) * state.totalTime),
    state.totalTime
  );
}

const handleMouseMove = (e: MouseEvent) => {
  if (!isDragging.value || !timelineRef.value) return
  draggingtime.value = getCurrentTime(e) as number;
}


const handleDocumentMouseUp = (e: MouseEvent) => {
  if (isDragging.value) {
    // 触发 onTimelineClick 的逻辑
    const currentTime = getCurrentTime(e) as number;
    resetPrompt()
    locateToTimePoint({locateTime: currentTime})
    resetDrawer(currentTime)
    // 延迟重置拖拽状态
    setTimeout(() => {
      isDragging.value = false
    }, 20)
  }
}

onBeforeMount(()=>{
  if(props.enterMode == 1){
    //从飞行页面进入需要调用resetView方法重置三维
    resetView({
      replayMode:1,
      trainingId:props.trainingId,
      canvasLimitHeight:getCanvasLimitHeight(store.state.persistence.resolution)
    })
  }
  if(props.enterMode == 2){
    isProgressRunning.value = true
    startProgress()
  }
})


onMounted(() => {
  if(props.enterMode == 2){
    store.commit('viewData/setIshowEngineView', true)
    store.commit("viewData/setEnterScene", true);
  }

  nextTick(() => {
    initEcharts('echartBox2')
    updateRadarData(props.abilityData)
  })
  // 计算 engineView 的位置
  updateEngineViewPosition()
  window.addEventListener('resize', handleResize)
  window.addEventListener('keydown', onKeydown);
  // 绑定 document mouseup 事件，处理鼠标在容器外部松开的情况
  document.addEventListener('mouseup', handleDocumentMouseUp)
})

onBeforeUnmount(()=>{
  if(props.enterMode == 2){
    if(progressTimer){
      stopProgress()
    }
    enterOrExitUavSimulateModule({
      enter:false,
    })
    store.commit('viewData/setIshowEngineView', false)
    store.commit("viewData/setEnterScene", false);
    store.commit("persistence/setStationId", null);
  }
})

onUnmounted(() => {
  // 恢复 engineView 到原始全屏状态
  store.commit('viewData/setEngineViewPosition',{width: '100%',height: '100%',top: '0px',left: '0px',zIndex: 'unset',})
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('keydown', onKeydown);
  // 解绑 document mouseup 事件
  document.removeEventListener('mouseup', handleDocumentMouseUp)
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fly-replay-container",
    style: _normalizeStyle({backgroundColor: props.enterMode == 2 ? '#15181D' : ''})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
          }, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "back",
              class: "icon"
            })
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "item-icon star-icon" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "icon"
              }),
              _createElementVNode("span", { class: "item-label" }, "得分")
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.score), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "item-icon check-icon" }, [
              _createElementVNode("img", {
                src: _imports_1,
                class: "icon",
                alt: ""
              }),
              _createElementVNode("span", { class: "item-label" }, "成绩")
            ], -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["item-value", __props.isPass ? 'pass' : 'fail'])
            }, _toDisplayString(__props.isPass ? '合格' : '不合格'), 3)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "item-icon thumb-icon" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "",
                class: "icon"
              }),
              _createElementVNode("span", { class: "item-label" }, "AI飞行评价")
            ], -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["item-value", getRatingClass(__props.rating)])
            }, _toDisplayString(__props.rating || '暂无评价'), 3)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "secen-box" }, null, -1)),
          (_unref(isProgressRunning))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: _unref($config).FILE_ROOT_PATH + props.scenePictureUrl,
                    alt: ""
                  }, null, 8, _hoisted_15),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-container" }, "正在加载中...", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_unref(NProgress), {
                        type: "line",
                        percentage: Number(progressValue.value),
                        "indicator-placement": "inside"
                      }, null, 8, ["percentage"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                      [_vShow, state.prompt_type === 'info']
                    ]),
                    _withDirectives(_createElementVNode("img", _hoisted_22, null, 512), [
                      [_vShow, state.prompt_type === 'error']
                    ]),
                    _createElementVNode("p", null, _toDisplayString(state.prompt_text), 1)
                  ])
                ], 512), [
                  [_vShow, state.showInfoPrompt]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon-box" }, [
                _createElementVNode("img", {
                  src: _imports_5,
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", _hoisted_25, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "title" }, "风向", -1)),
                _createElementVNode("p", null, _toDisplayString(props.windDirection), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icon-box" }, [
                _createElementVNode("img", {
                  src: _imports_6,
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", _hoisted_27, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "title" }, "风速", -1)),
                _createElementVNode("p", _hoisted_28, [
                  (__props.pageMode == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(windSpeed.value.label), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(windSpeed.value.value), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "unit" }, "m/s", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "horizontal-line line" }, null, -1)),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "vertical-line line" }, null, -1)),
              _createElementVNode("div", {
                class: "ball-container",
                style: _normalizeStyle({ left: `${state.joystickValue.leftX}%`, top: `${state.joystickValue.leftY}%` })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "horizontal-line line" }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "vertical-line line" }, null, -1)),
              _createElementVNode("div", {
                class: "ball-container",
                style: _normalizeStyle({ left: `${state.joystickValue.rightX}%`, top: `${state.joystickValue.rightY}%` })
              }, null, 4)
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", {
            class: "scene-3d-container",
            id: "fly-replay-engine-container"
          }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            _createVNode(miniMap, {
              "character-mode": 3,
              "allow-exchange-view": true
            })
          ], 512), [
            [_vShow, state.showMiniMap]
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", {
                class: "play-btn",
                onClick: handlePlayPause
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass([state.isPlaying?'iconfont-line vk_zt_line1':'iconfont-fill vk_jtzs_fill'])
                }, null, 2)
              ]),
              _createElementVNode("span", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, _toDisplayString(formatTime(currentTime.value)), 1),
                _createTextVNode(" / " + _toDisplayString(formatTime(state.totalTime)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", {
                class: "speed-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showSpeedDropdown.value = !showSpeedDropdown.value))
              }, [
                _createVNode(_component_vkm_svg, {
                  "icon-name": "vk_qh_line",
                  class: "icon"
                }),
                _createElementVNode("span", _hoisted_41, _toDisplayString(state.playbackSpeed) + "X", 1)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_42, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(speedOptions, (speed) => {
                  return _createElementVNode("div", {
                    key: speed,
                    class: _normalizeClass(["dropdown-item", { active: state.playbackSpeed === speed }]),
                    onClick: ($event: any) => (selectSpeed(speed))
                  }, _toDisplayString(speed) + "X ", 11, _hoisted_43)
                }), 64))
              ], 512), [
                [_vShow, showSpeedDropdown.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineItems.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "timeline-row",
                  key: item.label
                }, [
                  _createElementVNode("span", {
                    class: "timeline-label",
                    style: _normalizeStyle({ color: item.color })
                  }, _toDisplayString(item.label), 5)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "timeline-bar",
              ref_key: "containerRef",
              ref: containerRef,
              onWheel: _withModifiers(onWheel, ["prevent"]),
              onScroll: onScroll,
              onClick: onTimelineClick
            }, [
              _createElementVNode("div", {
                class: "timeline-track",
                style: _normalizeStyle({ width: trackWidth.value + '%' }),
                onMousemove: handleMouseMove
              }, [
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineItems.value, (timeLineItem) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "deviation-track",
                      key: timeLineItem.code
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineItem.evaluateAlarmList, (evaluateItem, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: _normalizeClass(['exception-bar',`exception-bar-${evaluateItem.code}`, { 'exception-bar-activate': evaluateItem.code == state.currentExceptionCode && idx == state.currentExceptionIndex }]),
                          style: _normalizeStyle(getStyle(evaluateItem.timestamp)),
                          onClick: _withModifiers(($event: any) => (playException(evaluateItem.timestamp, idx, evaluateItem.code)), ["stop"])
                        }, [
                          _createElementVNode("div", {
                            class: "center",
                            style: _normalizeStyle({ backgroundColor: timeLineItem.color })
                          }, null, 4)
                        ], 14, _hoisted_47))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "playhead",
                  id: "playheadId",
                  ref_key: "timelineRef",
                  ref: timelineRef,
                  style: _normalizeStyle({ left: playheadLeft.value + '%',cursor:'pointer', pointerEvents: state.isPlaying ? 'none' : 'auto' }),
                  onMousedown: handleMouseDown
                }, _cache[17] || (_cache[17] = [
                  _createElementVNode("div", { class: "inner" }, null, -1)
                ]), 36), [
                  [_vShow, timelineItems.value.length]
                ])
              ], 36)
            ], 544)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("span", { class: "card-title" }, "飞行轨迹")
          ], -1)),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", {
              class: "flight-path-container",
              ref_key: "drawRef",
              ref: drawRef
            }, null, 512)
          ])
        ]),
        _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"side-card ability-analysis-card\" data-v-475997af><div class=\"card-header\" data-v-475997af><span class=\"card-title\" data-v-475997af>能力分析</span></div><div class=\"card-content\" data-v-475997af><div id=\"echartBox2\" data-v-475997af></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_51, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("span", { class: "card-title" }, "飞行总结")
          ], -1)),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("p", _hoisted_53, _toDisplayString(__props.flightSummary), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("span", { class: "card-title" }, "AI教员训练建议")
          ], -1)),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", _hoisted_56, _toDisplayString(__props.trainingSuggestion), 1)
          ])
        ])
      ])
    ])
  ], 4))
}
}

})